import { theme } from "@coffee/theme";
import { ThemeProvider } from "@emotion/react";
import { ModalProvider } from "@unlikelyai-magic/ui/modals";
import { AppRouter } from "./AppRouter";

export default () => (
  <ThemeProvider theme={theme}>
    <ModalProvider>
      <AppRouter />
    </ModalProvider>
  </ThemeProvider>
);
